import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Dropdown } from '@ui/components/Dropdown';
import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';

import { RemovePlayerSetting } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const OPTIONS: { value: RemovePlayerSetting; label: ReactNode }[] = [
  { value: 'DoNotRemovePlayers', label: 'Ничего не делать' },
  {
    value: 'RemovePlayerAfterOneNoShow',
    label: 'Удалить участника после 1 неявки',
  },
  {
    value: 'RemovePlayerAfterTwoNoShows',
    label: 'Удалить участника после 2 неявок',
  },
];

export function RemoveAfterNoShowsInput() {
  const { control } = useFormContext<TournamentEditFormValues>();
  return (
    <FormRow>
      <FormLabel>Неявки</FormLabel>

      <FormInput>
        <Controller
          name="removePlayerSetting"
          control={control}
          defaultValue="RemovePlayerAfterTwoNoShows"
          render={({ field: { value, onChange, disabled } }) => (
            <Dropdown options={OPTIONS} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
